import axios from 'axios';
import useUserStore from '@/stores/user';
import type {AxiosRequestConfig, AxiosResponse, AxiosError} from 'axios';
import {ElMessage} from 'element-plus'

// 创建axios实例
const instance = axios.create({
    baseURL: import.meta.env.VITE_APP_BASE_API, // 设置API的基础URL
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
});

// 请求拦截器
instance.interceptors.request.use(
   (config: AxiosRequestConfig): any => {
     const userStore = useUserStore();
       // 可在请求发送前对 config 进行修改，如添加请求头等
     const headers = config.headers || {};
       // 从 localStorage 获取 token
       headers['Authentication'] = userStore.user_token;
       config.headers = headers;
       return config;
   },
   (error: AxiosError) => {
       // 处理请求错误
       return Promise.reject(error);
   }
);

// 响应拦截器
instance.interceptors.response.use(
    (response: AxiosResponse) => {
        // 对响应数据进行处理
        return response;
    },
    (error: AxiosError) => {
        console.log('error', error, error.status)
        if (error) {
            let errorMessage = '系统内部异常，请联系网站管理员'
            switch (error.status) {
                case 404:
                    ElMessage.error("很抱歉，资源未找到")
                    break
                case 403:
                    break
                case 401:
                    ElMessage.error("很抱歉，您无法访问该资源，可能是因为没有相应权限或者登录已失效")
                    setTimeout(() => {
                        location.reload()
                    }, 1000)
                    break
                case 503:
                    ElMessage.error(error.status + " -- 模块化服务尚未启动，请稍后重试")
                    break
                default:
                    ElMessage.error(errorMessage)
                    break
            }
        }
        return Promise.reject({code: -1, msg: '失败'})
    }
);


export default instance

// 封装GET请求
export function get<T>(url: string, params?: any, dynamic?:any): Promise<T> {
    let u=dynamic?url+'/'+dynamic:url
    return instance.get<T>(u, {params})
        .then(response => response.data)
        .catch(error => {
            throw error;
        });
}

// 封装POST请求
export function post<T>(url: string, data?: any): Promise<T> {
    return instance.post<T>(url, data)
        .then(response => response.data)
        .catch(error => {
            throw error;
        });
}

// put
export function put<T>(url: string, data?: any): Promise<T> {
    return instance.put<T>(url, data)
        .then(response => response.data)
        .catch(error => {
            throw error;
        });
}

//delete
export function del<T>(url: string): Promise<T> {
    return instance.delete<T>(url)
        .then(response => response.data)
        .catch(error => {
            throw error;
        });
}

// getFile
export function getFile<T>(url: string): Promise<T> {
    return instance.get(url, {
        responseType: 'blob'
    })
        .then(response => response)
        .catch(error => {
            throw error;
        })
}


// 导出
export function port<T>(url: string, params?: any): Promise<T> {
    return instance.post(url, params, {responseType: 'blob'})
        .then(response => {
            // 开发环境或跨域情况下 headers只能获取content-type
            let fileName = ''
            if (response.headers['content-disposition']){
                let temp = response.headers['content-disposition'].split(';')[1]
                if (temp.indexOf('filename=') !== -1 || temp.indexOf('fileName=') !== -1) {
                    fileName = temp.split('=')[1]
                }
                // fileName = response.headers['content-disposition'].split(';')[1].split('fileName=')[1]
            }
            const content = response.data
            const blob = new Blob([content])
            if (!fileName) {
                fileName = `${new Date().getTime()}_导出结果.xlsx`
            } else {
                fileName = decodeURI(fileName)
                let tempf = fileName.split('.')
                tempf[0] = new Date().getTime() + '_' + tempf[0] + '_导出结果'
                fileName = tempf.join('.')
            }
            if ('download' in document.createElement('a')) {
                const elink = document.createElement('a')
                elink.download = fileName
                elink.style.display = 'none'
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)
                elink.click()
                URL.revokeObjectURL(elink.href)
                document.body.removeChild(elink)
            }
            return response.data
        })
        .catch(error => {
            throw error;
        });
}

// 上传
export function upload<T>(url: string, params?: any): Promise<T> {
    return instance.post(url, params, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}
